(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.talentfunlResults = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var React = _interopRequireWildcard(_react);

var _reactDom = (typeof window !== "undefined" ? window['ReactDOM'] : typeof global !== "undefined" ? global['ReactDOM'] : null);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _talentfunlSearchkit = (typeof window !== "undefined" ? window['talentfunlSearchkit'] : typeof global !== "undefined" ? global['talentfunlSearchkit'] : null);

var _talentfunlSearchkit2 = _interopRequireDefault(_talentfunlSearchkit);

var _searchkit = (typeof window !== "undefined" ? window['searchkit'] : typeof global !== "undefined" ? global['searchkit'] : null);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Overwritte: talentfunl/assets/src/searchkit/results.jsx
 *
 * Important: This file is custom results component for Dr. Martens.
 * I've changed template so we need to be carefull with updating
 * talentfunl plugin without implementing changes here.
 *
 * @author PH
 */
var results = document.getElementById('search-' + ES.type + '-results');

var template = window['talentfunlTemplate_' + ES.type].default;

if (ES.type == 'employerprofile') {
	title = 'Employers';
}

var NoHitsDisplay = function NoHitsDisplay(props) {
	var bemBlocks = props.bemBlocks,
	    query = props.query,
	    suggestion = props.suggestion,
	    noResultsLabel = props.noResultsLabel;


	return React.createElement("div", { className: "no-results", dangerouslySetInnerHTML: { __html: wps.talentfunl.no_results } });
};

var NoHitsErrorDisplay = function NoHitsErrorDisplay(props) {
	var errorLabel = props.errorLabel,
	    bemBlocks = props.bemBlocks,
	    resetSearchFn = props.resetSearchFn,
	    tryAgainLabel = props.tryAgainLabel;


	return React.createElement(
		"div",
		{ "data-qa": "no-hits", className: bemBlocks.container() },
		React.createElement(
			"div",
			{ className: bemBlocks.container("info") },
			React.createElement(
				"h3",
				{ className: "sk-no-hits-info" },
				ES.translations.results.error
			)
		)
	);
};

var LoaderComponent = function LoaderComponent(props) {
	return React.createElement("div", { className: "loader" });
};

if (results) {
	ReactDOM.render(React.createElement(
		_searchkit.SearchkitProvider,
		{ searchkit: _talentfunlSearchkit2.default },
		React.createElement(
			"div",
			null,
			React.createElement(_searchkit.Hits, { hitsPerPage: parseInt(ES.per_page), itemComponent: template }),
			React.createElement(_searchkit.NoHits, {
				component: NoHitsDisplay,
				errorComponent: NoHitsErrorDisplay,
				suggestionsField: "positionTitle"
			}),
			React.createElement(_searchkit.InitialLoader, { component: LoaderComponent })
		)
	), results);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1])(1)
});
